import getHrefParams from "../helpers/getHrefParams";

document.addEventListener("DOMContentLoaded", () => {
  const tabs = document.querySelectorAll(".tabs__tab");
  const tabContentElems = Array.from(document.querySelectorAll(".tab-content"));

  if (tabs && tabs.length) {
    const showTab = (tab) => {
      tabs.forEach((t) => t.classList.remove("active"));
      tab.classList.add("active");

      const tabContent = tabContentElems.find((el) => el.dataset.tab === tab.dataset.tab);
      tabContentElems.forEach((el) => el.classList.remove("active"));
      tabContent?.classList.add("active");
    };

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        showTab(tab);
      });
    });

    let hrefParams = getHrefParams();
    if (hrefParams.card) {
      let needleTab = document.querySelector(`.tabs__tab[data-tab="${hrefParams.tab}"]`);
      // showTab(needleTab)
      showTab(tabs[0]);
    } else {
      showTab(tabs[0]);
    }
  }
});
